<template>
    <div>
        <video v-bind:key="1"
               v-show="currentVideo === 'car'"
               id="car-video"
               src="https://videos.ctfassets.net/u6w11btvnp5g/2jKPxn1NWm7cv4zpbqH6J/371971f19697415e04a735828e34ad8b/Perspektive_AUTO_FINAL_neu_1080p_2_8Mbit.mp4"
               playsinline
        ></video>
        <video v-bind:key="2"
               v-show="currentVideo === 'bike'"
               id="bike-video"
               src="https://videos.ctfassets.net/u6w11btvnp5g/2FuErpMkUgOYPghBuf8wvo/6efc6259df7f3309fc80f41d00567a0a/Perspektive_BIKE_FINAL_neu_1080p_2_8Mbit.mp4"
               playsinline
        ></video>
        <audio class="swoosh1" src="../assets/swoosh1.mp3"/>
        <audio class="swoosh2" src="../assets/swoosh2.mp3"/>

        <div @click.prevent.stop="_triggerQuestion"
             v-show="activeQuestion && ['all', currentVideo].includes(activeQuestion.showInVideo)"
             class="question-hot-indicator"
        >
          <img src="../assets/button_situation.svg" />
        </div>

        <div class="abdunkelung1"></div>
        <div class="abdunkelung2"></div>

        <div v-if="!finished" class="progression">
            <Progress
                ref="progressBar"
                :duration="duration"
                :blocked="blocked"
                :perspectiveStart="this.perspectiveStart"
                @toggle-car="switchTo('car')"
                @toggle-bike="switchTo('bike')"
                @toggle-play="togglePlay"
                @toggle-full="toggleFull"
            />
        </div>
    </div>
</template>

<script>
/*

 Bike medium https://videos.ctfassets.net/u6w11btvnp5g/41E8KxaykZPpnBt5vzk62t/62dca2e553a10c338556abf2073525b3/Perspektive_bike_KS_05_3.mp4
 Bike small https://videos.ctfassets.net/u6w11btvnp5g/5HnOuj8shvmVxDb3Mn4pQB/f926a13b245f2d0c933b6fa077af965d/Perspektive_bike_KS_05_2.mp4

 Car medium https://videos.ctfassets.net/u6w11btvnp5g/50XaqK5hlW5Y13tOoMYGrQ/691093341265bbf59d59e7d1e47f31e2/Perspektive_auto_KS_03_3.mp4
 Car small https://videos.ctfassets.net/u6w11btvnp5g/479KYcaZRNePh7RndOioXr/f5e6346e60487778a6bc39541cbfc84c/Perspektive_auto_KS_03_2.mp4

 */

import DeviceDetection from "../mixins/DeviceDetection.mixin";
import Perspectives from "../Perspectives";
import Progress from "./Progress";

export default {
  name: "VideoContainer",
  components: {Progress},
  mixins: [DeviceDetection],
  props: {
    questions: Array,
    rewind: Boolean,
    perspectiveStart: String
  },
  data() {
    return {
      currentVideo: this.perspectiveStart,
      currentTime: 0,
      duration: 0,
      videos: {},
      playing: true,
      activeQuestion: null,
      blocked: false,
      finished: false,
      swoosh: {
        car: null,
        bike: null
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.mapControls)
  },
  destroyed() {
    window.removeEventListener('keydown', this.mapControls)
  },
  mounted() {

    this.swoosh.car = document.querySelector('.swoosh2');
    this.swoosh.bike = document.querySelector('.swoosh1');

    Object.values(Perspectives).forEach((perspective) => {

      this.videos[perspective] = document.querySelector(
          '#' + perspective + '-video'
      );
      this.videos[perspective].addEventListener(
          'timeupdate',
          this._timeUpdate
      );

      if (perspective === this.currentVideo) {
        this.videos[perspective].focus();
        this.videos[perspective].addEventListener('durationchange', () => this.duration = this.videos[perspective].duration);
        this.videos[perspective].play();
        this.duration = this.videos[perspective].duration;
      }
    });

    setTimeout(() => {
      this.initDeviceDetection();
    }, 1000);
  },
  methods: {

    detectDeviceFeatures() {
      this.touchEnabled = this.hasTouchscreen();
      if (this.touchEnabled && this.playing) { // only mobile
        this.deviceOrientation = this.getDeviceOrientation();
        if (this.deviceOrientation === 'portrait') {
          this.togglePlay();
        }
      }
    },

    _timeUpdate(e) {

      if (!this.currentTime) {
          this.$nextTick(() => {
              this.videos[this.currentVideo].muted = false;
          });
      }

      this.currentTime = e.target.currentTime;

      if (this.$refs.progressBar) {
        this.$refs.progressBar.tick(
            this.currentTime,
            this.currentVideo,
            this.duration
        );
      }

      this._checkForQuestion(e.target.currentTime);
      this._checkEnd(e.target.currentTime);
    },
    _checkEnd(currentTime) {
      if (currentTime >= this.duration) {
        this.finished = true;
        this.$emit(
            'finished'
        );
      }
    },
    _checkForQuestion(currentTime) {

      // current stituation/question ended
      if (
          this.activeQuestion !== null
          && currentTime > this.activeQuestion.endAt
      ) {
        if (!this.activeQuestion.perspective) {
          this.activeQuestion.perspective = this.currentVideo;
        }
        this.$emit(
            'question-missed',
            this.activeQuestion,
            this.currentVideo
        );
        this.activeQuestion = null;

        this.$refs.progressBar.questionEnd();
      }

      this.questions.forEach((question) => {
        if (
            currentTime >= question.startAt
            && currentTime <= question.endAt
        ) {

          this.$refs.progressBar.question(
              currentTime >= question.showAt,
              currentTime >= (question.endAt - 1),
          );

          this.activeQuestion = question;

          if (this.rewind === true) {
            this._triggerQuestion();
          }
        }
      });
    },
    _triggerQuestion() {
      this.playing = false;
      this.blocked = true;
      this._pause();

      if (!this.activeQuestion.perspective) {
        this.activeQuestion.perspective = this.currentVideo;
      }
      this.$emit('question-found', this.activeQuestion)
    },
    mapControls(e) {
      if (this.blocked || this.finished) return;

      e.preventDefault();

      // console.log('DOWN ', e.key);

      const keyUp = (e) => {

        e.preventDefault();

        // console.log('UP ', e.key);

        if (e.key === 'Control') {
          this.togglePerspective();
        }
        else if (
            e.key === ' '
        ) {
          this.togglePlay(e);
        }
        else if (
            e.key === 'Alt'
            && this.activeQuestion !== null
            && ['all', this.currentVideo].includes(this.activeQuestion.showInVideo)
        ) {
          this.$refs.progressBar.buzz(
              this.activeQuestion.startAt,
              this.activeQuestion.showInVideo,
              this.duration,
              this.activeQuestion.id
          );
          this._triggerQuestion();
        }

        window.removeEventListener('keyup', keyUp);
        window.addEventListener('keydown', this.mapControls);
      }

      window.addEventListener('keyup', keyUp);
      window.removeEventListener('keydown', this.mapControls);
    },
    togglePlay(e) {
      if (this.blocked || this.finished || (e && e.target.tagName === 'BUTTON')) {
        return;
      }
      if (this.playing === true) {
        this._pause();
      } else {
        this._play();
      }
      this.playing = !this.playing;
    },
    toggleFull(e) {
      if (window.appIsFullScreen) {
        if (document.documentElement.requestFullscreen) {
          document.exitFullscreen();
        }
        else if (document.documentElement.webkitRequestFullscreen) {
          document.webkitExitFullscreen();
        }
        window.appIsFullScreen = false;
        this.$refs.progressBar.full(false);
      } else {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen();
        }
        window.appIsFullScreen = true;
        this.$refs.progressBar.full(true);
      }
    },
    _pause() {
      this.$refs.progressBar.paused(true);
      this.videos[this.currentVideo].pause();
    },
    _play() {
      this.$refs.progressBar.paused(false);
      this.videos[this.currentVideo].play();
    },
    pause() {
      if (this.finished) return;

      if (this.playing) {
        this._pause();
      }
      return this.playing;
    },
    resume() {
      if (this.finished) return;

      this._play();
    },
    async togglePerspective() {
      if (this.finished) return;

      // this.swoosh[this.currentVideo].stop();
      // this.swoosh[this.currentVideo].play();

      let otherPerspective = this.currentVideo === Perspectives.car
          ? Perspectives.bike
          : Perspectives.car
      ;

      this.videos[this.currentVideo].pause();
      this.videos[otherPerspective].currentTime = this.videos[this.currentVideo].currentTime;

      this.swoosh[this.currentVideo].play();
      this.$refs.progressBar.switch(
          this.currentTime,
          otherPerspective,
          this.duration
      );

      const videoSwitch = async () => {
          this.videos[otherPerspective].removeEventListener('timeupdate', videoSwitch);
          await (new Promise(resolve => setTimeout(resolve, 200)));
          this.currentVideo = otherPerspective;
      };
      this.videos[otherPerspective].addEventListener('timeupdate', videoSwitch)

      if (this.playing) {
        this.videos[otherPerspective].play();
        // this.videos[otherPerspective].muted = true;
      }
    },
    rewindTo(time) {
      if (this.finished) return;

      this.videos[this.currentVideo].currentTime = this.currentTime = time;
      this.$refs.progressBar.questionEnd();
      this.$refs.progressBar.rewind(this.currentTime, this.duration);

      this.continue();
    },
    switchTo(perspective) {
      if (perspective !== this.currentVideo) this.togglePerspective();
    },
    continue(questionAnswered = false) {
      if (this.finished) return;

      console.log(questionAnswered);
      if (questionAnswered === true) {
        this.$refs.progressBar.questionEnd(
            true,
            this.activeQuestion.startAt,
            this.activeQuestion.showInVideo,
            this.duration,
            this.activeQuestion.id
        );
      }

      this.activeQuestion = null;
      this.blocked = false;
      this.playing = true;

      this._play();
    }
  },
  computed: {
    videoBounds() {
      return this.videos[Perspectives.car].getBoundingClientRect();
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

.question-hot-indicator {
  position: absolute;
  display: none;
}

.mobile {
  .question-hot-indicator {
    display: block;
  }
}

@media(min-aspect-ratio: 16/9) {
  .mobile {
    .question-hot-indicator {
      right: scaleMobileVh(26);
      top: scaleMobileVh(173);
      img {
        width: scaleMobileVh(30);
        height: scaleMobileVh(30);
      }
    }
  }
}
@media(max-aspect-ratio: 16/9) {
  .mobile {
    .question-hot-indicator {
      right: scaleMobileVw(26);
      top: scaleMobileVw(173);
      img {
        width: scaleMobileVw(30);
        height: scaleMobileVw(30);
      }
    }
  }
}

.progression {
    position: absolute;
    bottom: 2%;
    width: 100%;
}


video {
    width: 100%;
    height: 100%;
}

.controls {
    display: flex;
    position: absolute;
    top: 0;
    width: 100%;
}

progress {
    display: block;
    width: 100%;
    height: 1em;
    -webkit-appearance: none;
    appearance: none;
}

progress::-webkit-progress-bar {
    background-color: rgba(0, 0, 0, 0.2);
}

progress::-webkit-progress-value {
    background-color: rgba(255, 255, 255, 0.6);
}

</style>